import { render } from "./Concessions.vue?vue&type=template&id=4e1c64bf&scoped=true"
import script from "./Concessions.vue?vue&type=script&lang=js"
export * from "./Concessions.vue?vue&type=script&lang=js"

import "./Concessions.vue?vue&type=style&index=0&id=4e1c64bf&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e1c64bf"]])

export default __exports__